import React, { FC } from 'react';
import styles from './index.module.scss';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import { Ownerships, ownership } from 'src/models/ownership';
import { FilterAssigned, FilterBuyer, FilterClear, FilterCodes, FilterDates, FilterSearch } from 'src/shared';
import { TendersTypesVars } from 'src/models/procurements/Tenders/types';

export const Filters: FC = () => {
  const [{ eventSource: type }] = useApiTenders();
  const filters: TendersTypesVars[typeof type] = [
    'assignedTo',
    'buyerOrgIds',
    'buyerSearchStrings',
    'cpvCodes',
    'deadline',
    'nutsCodes',
    'published',
    'search'
  ];

  return (
    <div className={styles.bar}>
      <FilterSearch />
      <FilterBuyer />
      <FilterDates />
      {ownership.name !== Ownerships.Clira && <FilterAssigned />}
      <FilterCodes type={'cpvCodes'} />
      <FilterCodes type={'nutsCodes'} />
      <FilterClear filters={filters} />
    </div>
  );
};

export default Filters;
